/* src/app/ai-studio/ai-studio.component.css */
:host {
  display: block;
  height: 100%;
  width: 100%;
}
.session-host-active {
  display: flex;
  height: 100%;
  width: 100%;
  background-color: var(--surface-b);
  padding: 0 0.5rem 0.25rem 0.5rem;
  box-sizing: border-box;
}
.chat-pane {
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-a);
  border-right: 1px solid var(--surface-d);
  padding: 0.5rem;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}
.chat-header {
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid var(--surface-d);
  flex-shrink: 0;
}
.chat-messages-container {
  flex-grow: 1;
  overflow: hidden;
  margin-bottom: 1rem;
  background-color: white;
}
.chat-input-group {
  flex-shrink: 0;
}
.chat-messages {
  padding: 10px;
}
.user-message {
  text-align: right;
  margin-bottom: 4px;
}
.other-message {
  text-align: left;
}
.message-sender {
  font-weight: bold;
}
.message-content-bot {
  background-color: #eee;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 5px;
}
.message-content-user {
  background-color: #b7d086;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 5px;
}
.shortcut-suggestion-item {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}
.shortcut-command {
  font-weight: bold;
}
.shortcut-description {
  font-size: 0.9em;
  color: #6c757d;
}
.message-timestamp {
  font-size: 0.8em;
  color: #999;
  margin-bottom: 20px;
}
.canvas-pane {
  flex: 1 1 70%;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-b);
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}
.canvas-header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--surface-d);
  background-color: var(--surface-a);
}
.canvas-content {
  flex-grow: 1;
  padding: 1rem;
  overflow-y: auto;
}
.loading-session {
  padding: 2rem;
  text-align: center;
}
.full-height-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.message-sender-info {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-weight: bold;
}
.sender-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
  border: 1px solid #eee;
}
.message-sender-name {
  font-size: 0.9em;
}
.user-message .message-content-user,
.other-message .message-content-bot {
}
.user-message .message-sender-info {
  justify-content: flex-end;
}
.user-message .message-sender-info .sender-avatar {
  margin-left: 8px;
  margin-right: 0;
  order: 1;
}
.user-message .message-sender-info .message-sender-name {
  order: 0;
}
.chat-input-group .chat-autocomplete {
  width: 100%;
  display: flex;
}
.chat-input-group .chat-autocomplete .chat-textarea,
.chat-input-group .chat-autocomplete .p-inputtextarea {
  flex-grow: 1;
  width: 100%;
  border: none;
  padding: 0.75rem;
  box-sizing: border-box;
  resize: none;
  min-height: 47px;
  line-height: 1.5;
}
.mention-suggestion-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
}
.mention-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 0.5rem;
  object-fit: cover;
}
.mention-name {
  font-weight: bold;
}
.mention-email {
  font-size: 0.85em;
  color: var(--text-color-secondary);
  margin-left: 0.25rem;
}
.chat-input-group .p-inputgroup-addon {
  display: flex;
  align-items: center;
  height: auto;
  min-height: 47px;
}
.inline-mention-chip {
  margin: 0 0.25rem;
  vertical-align: middle;
}
@media (prefers-color-scheme: dark) {
  .chat-pane {
    background-color: var(--surface-b);
    border-right-color: var(--surface-border);
  }
  .chat-messages-container {
    background-color: var(--surface-c);
  }
  .message-content-user {
    background-color: gray;
    color: var(--primary-color-text);
  }
  .message-content-bot {
    background-color: darkgreen;
    color: var(--text-color);
  }
  .sender-avatar {
    border-color: var(--surface-d);
  }
  .shortcut-description {
    color: var(--text-color-secondary);
  }
  .message-timestamp {
    color: var(--text-color-secondary);
  }
}
/*# sourceMappingURL=ai-studio.component-FFICADM7.css.map */
